export default __webpack_public_path__ + "static/media/negrao.bcea1632.jpg";